import React, { useEffect, useState } from 'react'
import { Pagination } from 'react-bootstrap';
import { Search } from "react-bootstrap-icons";
import './Pagination.css';


type PropTypes = {
    totalPages: number;
    pageLimit: number;
    onPageChanged: Function
    disablePagination: boolean;
    isRefreshPage: boolean;
    setIsRefreshPage: Function;
}
const ApplicationPagger = (props: PropTypes) => {

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [inputCurrentPage, setInputCurrentPage] = useState<number>(1);

    let { totalPages, pageLimit, onPageChanged, disablePagination, isRefreshPage } = props;
    if (totalPages === 0) {
        totalPages = 1;
    }
    const gotoPage = (page: number) => {
        const changedPage = Math.max(1, Math.min(page, totalPages));
        setCurrentPage(changedPage);
    }

    useEffect(() => {
        onPageChanged(1);
        setCurrentPage(1);
        setInputCurrentPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageLimit])

    useEffect(() => {
        if (isRefreshPage) {
            setInputCurrentPage(1);
            setCurrentPage(1);
            props.setIsRefreshPage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRefreshPage])

    useEffect(() => {
        onPageChanged(currentPage);
        setInputCurrentPage(currentPage)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage])

    useEffect(() => {
        if (currentPage > totalPages) {
            gotoPage(1);
            setInputCurrentPage(1);
        }
    }, [totalPages]);

    // useEffect(() => {
    //     if (currentPage > totalPages) {
    //         setCurrentPage(1);
    //         setInputCurrentPage(1);
    //     }
    // }, [totalPages]);

    useEffect(() => {
        gotoPage(1);
        setInputCurrentPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCurrentPage = () => {
        gotoPage(inputCurrentPage);
    }

    const handleMoveFirst = (e: any) => {
        e.preventDefault();
        gotoPage(1);

    }

    const handleMoveLast = (e: any) => {
        e.preventDefault();
        gotoPage(totalPages);
    }

    const handleMoveNext = (e: any) => {
        e.preventDefault();
        gotoPage(currentPage + 1);
    }

    const handleMovePrev = (e: any) => {
        e.preventDefault();
        gotoPage(currentPage - 1);

    }

    const onInputPageChanged = (e: any) => {
        let numRegex = /^[0-9\b]+$/;
        if (e.target.value === '' || numRegex.test(e.target.value)) {
            setInputCurrentPage(e.target.value)
        }
    }

    const inputChanged = (e: any) => {
        if (e.target.value === "")
            setInputCurrentPage(currentPage);
    }

    return (
        <div className="panelTablePagination">
            <Pagination>
                <Pagination.First as="span" onClick={handleMoveFirst} disabled={disablePagination} />
                <Pagination.Prev as="span" onClick={handleMovePrev} disabled={disablePagination} />
                <div className='customPages'>
                    <span className='currentPage'>
                        <input type="text" name="currentPage" value={inputCurrentPage} className='pageInput' onChange={onInputPageChanged} onBlur={inputChanged} />
                        <span className={( inputCurrentPage <= totalPages && inputCurrentPage > 0)  ? "searchIcon" : "searchIcon disabled-class"} onClick={handleCurrentPage}><Search /> </span>
                    </span>
                    <span className='totalpages'> / {totalPages}</span>
                </div>
                <Pagination.Next as="span" onClick={handleMoveNext} disabled={disablePagination} />
                <Pagination.Last as="span" onClick={handleMoveLast} disabled={disablePagination} />

            </Pagination>
        </div>

    )
}

export default ApplicationPagger;